export const NFE_CONTENT = {
  hero: {
    kicker: 'Para empresas que vendem produtos',
    title: 'Pare de perder venda por causa de nota fiscal rejeitada.',
    subtitle:
      'Emita NF-e e NFC-e direto da tela de venda ou do PDV, com os impostos calculados automaticamente e transmissão direta à SEFAZ. Sem sistema separado, sem digitar tudo de novo.',
    cta: 'Quero emitir nota sem dor de cabeça',
    ctaMessage: 'Quero conhecer o emissor de NF-e do 77Gestão',
    urgency: 'Cada nota rejeitada é uma venda parada e um cliente esperando no caixa.',
  },

  statsStrip: [
    { number: '1 clique', label: 'para emitir direto da venda', icon: 'fa-solid fa-bolt' },
    { number: 'Direto', label: 'à SEFAZ, sem intermediário manual', icon: 'fa-solid fa-building-shield' },
    { number: 'Zero', label: 'cálculo manual de imposto', icon: 'fa-solid fa-calculator' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações? Então a nota fiscal está custando mais caro do que devia.',
    intro:
      'Empresas que vendem produtos perdem tempo e vendas todos os dias por causa de um processo de emissão de nota que devia ser simples. Não é falta de cuidado — é falta da ferramenta certa.',
    items: [
      { icon: 'fa-solid fa-triangle-exclamation', text: 'Nota rejeitada pela SEFAZ na hora da venda, com o cliente esperando no caixa.' },
      { icon: 'fa-solid fa-calculator', text: 'Cálculo manual de ICMS, IPI, PIS e COFINS, sujeito a erro em cada produto.' },
      { icon: 'fa-solid fa-arrows-rotate', text: 'Sistema de emissão separado do sistema de vendas — digitar os dados duas vezes.' },
      { icon: 'fa-solid fa-file-circle-xmark', text: 'Cancelamento de nota fiscal complicado, sem protocolo organizado.' },
      { icon: 'fa-solid fa-user-tie', text: 'Depender do contador ou de outra pessoa só para emitir ou corrigir uma nota.' },
    ],
  },

  midCta: {
    text: 'E se toda venda gerasse a nota fiscal certa, na hora, sem sair da tela?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do emissor de NF-e do 77Gestão',
  },

  solution: {
    title: 'Emissão de nota fiscal integrada à venda. Sem sistema paralelo, sem retrabalho.',
    intro:
      'O emissor de NF-e do 77Gestão foi construído para quem vende produto e precisa de agilidade sem abrir mão da conformidade fiscal.',
    cards: [
      {
        icon: 'fa-solid fa-cash-register',
        title: 'NF-e e NFC-e direto da venda ou do PDV',
        text: 'Feche a venda e a nota sai junto — sem redigitar nada em outro sistema.',
      },
      {
        icon: 'fa-solid fa-calculator',
        title: 'Cálculo automático de impostos',
        text: 'ICMS, IPI, PIS e COFINS calculados por NCM e pelo cenário fiscal configurado em cada produto. O sistema reduz drasticamente o erro humano.',
      },
      {
        icon: 'fa-solid fa-satellite-dish',
        title: 'Transmissão direta à SEFAZ',
        text: 'A nota vai direto para a Receita, sem passos manuais no meio do caminho.',
      },
      {
        icon: 'fa-solid fa-file-circle-check',
        title: 'Cancelamento com protocolo legal',
        text: 'Errou uma nota? Cancele dentro do sistema, com protocolo registrado e dentro do prazo.',
      },
      {
        icon: 'fa-solid fa-clock-rotate-left',
        title: 'Histórico completo de notas emitidas',
        text: 'Consulte qualquer nota, de qualquer período, sem procurar em pasta de e-mail ou XML solto.',
      },
      {
        icon: 'fa-solid fa-file-import',
        title: 'Monitoramento de notas de fornecedor',
        text: 'O sistema acompanha automaticamente as notas emitidas contra o CNPJ da sua empresa e já lança a conta a pagar — inclusive com importação do XML.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a nota fiscal para de ser um gargalo na venda',
    intro:
      'Uma distribuidora que emitia nota em um sistema separado do PDV perdia minutos preciosos em cada venda — e volume relevante de notas rejeitadas por erro de digitação ou de cálculo de imposto.',
    stats: [
      { number: '1 clique', label: 'da venda até a nota emitida' },
      { number: '↓', label: 'queda nas rejeições por erro manual' },
      { number: '100%', label: 'das notas rastreadas em um só lugar' },
    ],
    paragraphs: [
      'Depois da implantação, a nota passou a sair automaticamente no fechamento da venda, com os impostos já calculados conforme o cenário fiscal de cada produto.',
      'O time de caixa parou de perder tempo corrigindo nota rejeitada, e o financeiro passou a receber automaticamente as notas de fornecedor recebidas contra o CNPJ da empresa, sem depender de conferência manual de e-mail.',
    ],
    highlight: 'Resultado: venda mais rápida, muito menos erro fiscal e nenhuma nota de fornecedor passando despercebida.',
    cta: 'Quero esse nível de agilidade',
    ctaMessage: 'Vi o resultado e quero entender como emitir NF-e sem erro no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares de uma emissão de nota fiscal sem dor de cabeça',
    items: [
      {
        icon: 'fa-solid fa-bolt',
        title: 'Agilidade',
        text: 'A nota sai junto com a venda, sem passos extras e sem sistema paralelo para alimentar.',
      },
      {
        icon: 'fa-solid fa-shield-halved',
        title: 'Conformidade',
        text: 'Impostos calculados por NCM e cenário fiscal configurado, com transmissão direta à SEFAZ.',
      },
      {
        icon: 'fa-solid fa-link',
        title: 'Integração',
        text: 'Venda, estoque, financeiro e nota fiscal no mesmo sistema. Um lançamento alimenta tudo.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o 77Gestão para emitir nota fiscal',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'Emissão integrada à venda e ao PDV — não é um módulo separado para alimentar.' },
      { icon: 'fa-solid fa-file-import', text: 'Monitoramento automático de notas de fornecedor contra o seu CNPJ, com lançamento direto no contas a pagar.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: a configuração fiscal de cada produto é feita junto com você.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano de verdade quando uma nota trava — sem fila de ticket.' },
      { icon: 'fa-solid fa-layer-group', text: 'Tudo integrado com estoque e financeiro: a venda dá baixa, gera a nota e já lança o financeiro.' },
    ],
  },

  faq: {
    title: 'Dúvidas antes de emitir sua primeira nota',
    items: [
      {
        question: 'Preciso de certificado digital para emitir NF-e?',
        answer:
          'Sim, o certificado digital da empresa é obrigatório para a transmissão da nota à SEFAZ, como em qualquer emissor. Ele é configurado uma única vez no sistema durante a implantação.',
      },
      {
        question: 'O sistema calcula os impostos sozinho?',
        answer:
          'Sim. Você configura o cenário fiscal de cada produto uma vez (NCM, alíquotas de ICMS, IPI, PIS e COFINS) e o sistema aplica o cálculo automaticamente em cada venda, reduzindo drasticamente o erro manual.',
      },
      {
        question: 'Funciona também para NFC-e no PDV?',
        answer:
          'Sim. O 77Gestão emite tanto NF-e quanto NFC-e direto da tela de venda ou do PDV, conforme o tipo de operação.',
      },
      {
        question: 'E se a SEFAZ rejeitar uma nota?',
        answer:
          'O sistema mostra o motivo da rejeição na hora, para correção imediata sem travar o restante da operação de venda.',
      },
      {
        question: 'Consigo cancelar uma nota emitida por engano?',
        answer:
          'Sim, dentro do prazo legal o cancelamento é feito direto no sistema, com protocolo registrado.',
      },
    ],
  },

  ctaFinal: {
    title: 'Nota fiscal não devia ser o gargalo da sua venda.',
    subtitle:
      'Agende uma demonstração gratuita e veja como emitir NF-e e NFC-e direto da venda, com impostos calculados automaticamente e transmissão direta à SEFAZ.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do emissor de NF-e do 77Gestão',
  },

  seo: {
    title: 'Emissor de NF-e Online para Empresas | 77Gestão',
    description:
      'Sistema de emissão de nota fiscal com NF-e e NFC-e direto da venda ou do PDV, cálculo automático de impostos e transmissão direta à SEFAZ. Fale com a gente.',
  },
};
